"use client";

import React from 'react';
import Header from './Header';
import GlobalBackground from './GlobalBackground';
import HeroSection from './HeroSection';
import StatsBar from './StatsBar';
import FeaturesGrid from './FeaturesGrid';
import HowItWorks from './HowItWorks';
import LivePreview from './LivePreview';
import BenefitsSection from './BenefitsSection';
import CTASection from './CTASection';
import Footer from './Footer';

const MainPage = () => {
    return (
        <div className="relative min-h-screen transition-colors duration-500 overflow-x-hidden">
            <GlobalBackground />
            <Header />
            <main className="relative z-10">
                {/* Hero Section */}
                <HeroSection />

                {/* Main Content Sections */}
                <div className="space-y-12 sm:space-y-24">
                    {/* Stats Section */}
                    <StatsBar />

                    {/* Features Section */}
                    <div id="features">
                        <FeaturesGrid />
                    </div>

                    {/* How it Works Section */}
                    <div id="how-it-works">
                        <HowItWorks />
                    </div>

                    {/* Live Preview / Interactive Section */}
                    <LivePreview />

                    {/* Benefits Section */}
                    <div id="benefits">
                        <BenefitsSection />
                    </div>

                    {/* Final CTA Section */}
                    <CTASection />
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default MainPage;